/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 29/6/21.
 */

import config from "@/config"
import axios from "axios";
import store from "@/store";
import {uuid} from "vue-uuid";

export default {
	getPlaylistBySchedule(station_id, from, to, params) {
		return axios.get(
			`${config.ZETTA_URL}/playlist/byschedule/${station_id}/${from}/${to}`,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				},
				params
			}
		);
	},

	getPlaylistWithAssetsBySchedule(station_id, from, to, params = {}) {
		return axios.get(
			`${config.ZETTA_URL}/playlist/withAssetData/byschedule/${station_id}/${from}/${to}`,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				},
				params: {...params, replaceCommonAssetDataWithStationAssetData: true}
			}
		);
	},

	getPlaylistByShowEpisodeID(show_episode_id) {
		return axios.get(
			`${config.ZETTA_URL}/playlist/byShowEpisodeID/${show_episode_id}`,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				},
			}
		);
	},

	getPlaylistWithAssetsByShowEpisodeID(StationID, show_episode_id) {
		return axios.get(
			`${config.ZETTA_URL}/playlist/withAssetData/byShowEpisodeID/${show_episode_id}`,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				},
				params: {
					StationID,
					replaceCommonAssetDataWithStationAssetData: true
				}
			}
		);
	},

	getPlaylistWithAssets(playlistID) {
		return axios.get(
			`${config.ZETTA_URL}/playlist/withAssetData/${playlistID}`,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				},
				params: {replaceCommonAssetDataWithStationAssetData: true}
			}
		);
	},

	getAirTimes(playlists) {
		return axios.post(
			`${config.UTIL_URL}/RecalcPlaylist`,
			playlists,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	getPlaylistById(playlistID) {
		return axios.get(`${config.ZETTA_URL}/playlist/${playlistID}`, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	createPlaylist(playlist) {
		return axios.post(
			`${config.ZETTA_URL}/playlist`,
			playlist,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	updatePlaylist(payload) {
		return axios.patch(
			`${config.ZETTA_URL}/playlist/${payload.playlistID}`,
			{TargetLength: payload.TargetLength},
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	generateSequenceNumber({eventID, afterEvent}) {
		return axios.get(`${config.ZETTA_URL}/event/generateSequenceNumber/${eventID}/${afterEvent}`, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	createPlaylistEvent(payload) {
		return axios.post(
			`${config.ZETTA_URL}/event/`,
			payload,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	updatePlaylistEvent(payload) {
		return axios.patch(
			`${config.ZETTA_URL}/event/${payload.EventID}`,
			payload,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	deletePlaylistEvent(eventID) {
		return axios.delete(
			`${config.ZETTA_URL}/event/${eventID}`,
			{
				headers: {
					"Authorization": store.state.accessToken,
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		);
	},

	getDefaultAssetTypes() {
		return axios.get(
			`${config.ZETTA_URL}/organization/${store.getters.getOrgID()}?includeStations=false`,
			{
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"z-cloud-org-id": store.getters.getOrgID()
				}
			}
		)
	},

	resolveTag(params) {
		let url = `${config.ZETTA_URL}/rotation/graphql`

		const dateTimeFields = params.searchShowDateTime ? `
										searchShowDateTime: "${params.searchShowDateTime}",
										targetDateTime: "${params.searchShowDateTime}",
  										` : "";

		return axios.post(url, {
			query:
				`mutation {
				  resolveVoiceTagEvent(
					input: {
						resolveKey: "${uuid.v1()}",
						stationId: "${params.stationID}",
						eventId: "${params.eventID}",
						searchPlaylistId: "${params.playlistID}",
						${dateTimeFields}
						assetTypes: [${params.assetTypes}],
						overwrite: true,
						autoCreate: true,
						alwaysCreate: true,
						fallbackVoices: ["[DEFAULT]"],
					}
				  ) {
					resolveKey
					resolveRotationId
					resolveRequest {
						resolveKey
						stationId
						voices
						tags
						assetTypes
						autoCreate
						alwaysCreate
						regenerate
						dryRun
						count
						endAction
					}
					resolveAssets {
					  assetId
					  sequenceNumber
					}
					resolveReason
				  }}`.replace(/\s/g, ' ')
			}, {
				headers: {
					"Authorization": store.getters.getAccessToken(),
					"Z-Cloud-Org-Id": store.getters.getOrgID()
				}
			}
		);
	}
}
